import { FaExclamationTriangle } from "react-icons/fa";
import { Box } from "@mui/system";
import { Modal } from "@mui/material";
import { useTranslation } from "react-i18next";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 400,
  minWidth: 300,
  bgcolor: "white",
  boxShadow: 24,
  p: 4,
  borderRadius: 5,
};

const PurchaseOfferModel = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation("add_guest");  

  return (
    <Modal
  disableScrollLock={true}
  open={open}
  onClose={onClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box sx={style}>
    <center>
      <div className="icon-div">
        <FaExclamationTriangle size={50} className="text-[#3686FF]" />
      </div>
      <div className="py-4">
        <span className="font-bold text-[20px] text-[#3686FF]">
          {t('upgrade_your_plan')}
        </span>
      </div>
      <span className="text-gray-500 font-semibold">
        {t('limit_exceeded_msg')}
      </span>
      <div className="flex gap-3 justify-center pt-4">
      <button
  onClick={onClose}
  className="flex-1 px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors whitespace-normal"
>
  {t('btn_cancel')}
</button>
<button
  onClick={() => {
    onConfirm();
    onClose();
  }}
  className="flex-1 px-4 py-2 text-white bg-[#3686FF] rounded-lg transition-colors whitespace-normal"
>
  {t('btn_upgrade')}
</button>
      </div>
    </center>
  </Box>
</Modal>

  );
};

export default PurchaseOfferModel;
